import { render, staticRenderFns } from "./BenefitIcon.vue?vue&type=template&id=722f0454&scoped=true&"
import script from "./BenefitIcon.vue?vue&type=script&lang=js&"
export * from "./BenefitIcon.vue?vue&type=script&lang=js&"
import style0 from "./BenefitIcon.vue?vue&type=style&index=0&id=722f0454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f0454",
  null
  
)

export default component.exports